import {useQuery} from "@tanstack/react-query";
import verifyAccount from "../api/verificationLink";

const useVerifyAccount = (email: string | null, pin: string | null) => {
  const query = useQuery({
    queryKey: ["verifyAccount", email, pin],
    queryFn: async () => {
      if (!email || !pin) {
        throw new Error("Invalid or missing verification details.");
      }
      return await verifyAccount(email, pin);
    },
    enabled: Boolean(email && pin),
    retry: false,
  });

  return {
    verifyData: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    isFetching: query.isFetching,
    refetch: query.refetch,
  };
};

export default useVerifyAccount;
